<template>
  <h2 class="text-xl font-bold mt-4 mb-2 text-gray-700 w-full">
    <a href="" name="changelog"></a>
    About Slipmat EventPlanner
  </h2>

  <div class="changelog">
    <p>
      This is a <strong>tool for planning, scheduling and organizing events</strong>. The design
      main focus has been on online events and festivals where timezones are important, but it works
      for physical events as well.
    </p>

    <p>
      While the planner is tightly integrated for working with Slipmat.io live stream events, it can
      be used to plan and organize any kind of events for any online platform or physical space.
    </p>

    <p class="font-bold text-gray-800">Planned features:</p>

    <ul class="list-disc">
      <li>Automatic timezone calculations between local and event times</li>
      <li>Schedule building for one or multiple stages / tracks</li>
      <li>Easy tools for managing and tracking event and artist-based tasks</li>
      <li>
        Easy tools for communicating with artists (w/ read notifications and obligatory
        read/understood-checks)
      </li>
      <li>Clear and simple artist info builder</li>
      <li>
        Built-in chat with separate channels for staff and artists
      </li>
      <li>
        Mobile-friendly version for artists and stripped-down mobile version for staff
      </li>
      <li>
        Everything is automatically versioned so no info is ever lost and clear revision numbers on
        documentation and schedules minimize confusion
      </li>
      <li>User management with simple access levels</li>
      <li>For physical event organizers:</li>
      <ul class="list-disc">
        <li>budgeting</li>
        <li>inventory management</li>
        <li>integrations to third-party sales / invoicing tools</li>
        <li>flexible and complete data exports</li>
      </ul>

      <li>
        For Slipmat users:
        <ul class="list-disc">
          <li>automatic artist integration</li>
          <li>automatic event creation</li>
        </ul>
      </li>
    </ul>

    <p>
      The tool helps tremendously with organizing any larger events as the data can be kept at one
      place and the communication is transparent. But the main benefits come from repeated events
      when the old data from previous events can be used as basis for the next ones and artists can
      update their own data etc.
    </p>
  </div>
</template>
